import axios from 'axios';

export const getTermsStatus = async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/terms/status`);
  return response.data;
};

export const agreeTerms = async (agreements) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/terms/agree`, {
    agreements,
  });
  return response.data;
};
